import { FilterCheckboxGroup } from '@app/components/molecules/filter-checkbox-group';
import { FilterRadioGroup } from '@app/components/molecules/filter-radio-group';
import { FilterRangeSlider } from '@app/components/molecules/filter-range-slider';
import { FilterComponentType, FilterGroup } from '@app/components/organisms/filter-items';

export const filterComponents = {
    [FilterComponentType.CHECKBOX_GROUP]: (item: FilterGroup, id: number) => {
        if (item.componentType !== FilterComponentType.CHECKBOX_GROUP) return null;

        return <FilterCheckboxGroup key={id} {...item} />;
    },

    [FilterComponentType.RANGE_SLIDER]: (item: FilterGroup, id: number) => {
        if (item.componentType !== FilterComponentType.RANGE_SLIDER) return null;

        return <FilterRangeSlider key={id} {...item} />;
    },

    [FilterComponentType.RADIO_GROUP]: (item: FilterGroup, id: number) => {
        if (item.componentType !== FilterComponentType.RADIO_GROUP) return null;

        return <FilterRadioGroup key={id} {...item} />;
    },
};
